import React, { Component } from "react";
import { Button } from "react-bootstrap";
import Slider from "react-slick";

const MainSlider = ({ banners }) => {
  const settings = {
    dots: true,
    fade: true,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      <Slider {...settings}>
        {banners &&
          banners.length &&
          banners.map((b, index) => {
            return (
              <div className="position-relative" key={index}>
                <img src={b.link} alt="First Slide" />
                {(b?.ctabtns.length &&
                  b.ctabtns.map((c, i) => {
                    return (
                      <div key={i} className="banner-btn">
                        
                        <Button
                          variant="primary"
                          className="start-btn"
                          onClick={() => {
                            window.location.href = c.actionLink;
                          }}
                        >
                          {c.label}
                        </Button>
                      </div>
                    );
                  })) ||
                  null}
              </div>
            );
          })}
      </Slider>
    </>
  );
};

export default MainSlider;
